import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsInfoSecurityScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.InfoInfoSecurity />
    </View>
  );
};

export default PreProposalsInfoSecurityScreen;
